<template>
  <svg :width="width" :height="height" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="success11111" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="09-ssssssss" transform="translate(-861.000000, -766.000000)" fill="#52C41A">
        <g id="ssbbdddd" transform="translate(680.500000, 731.000000)">
          <g id="Success11111" transform="translate(181.000000, 35.000000)">
            <path id="Shape" d="M15,30 C6.71554252,30 0,23.2844575 0,15 C0,6.71554252 6.71554252,0 15,0 C23.2844575,0 30,6.71554252 30,15 C30,23.2844575 23.2844575,30 15,30 L15,30 Z M24.0674487,18.9765396 L11.8856305,7.1202346 C11.5190616,6.75366569 10.9237537,6.75366569 10.5571848,7.1202346 L5.90322581,11.568915 C5.53665689,11.9354839 5.53665689,12.5307918 5.90322581,12.8973607 L5.90322581,12.8973607 C6.26979472,13.2639296 6.86510264,13.2639296 7.23167155,12.8973607 L11.2228739,9.11143695 L22.7390029,20.3049853 C23.1055718,20.6715543 23.7008798,20.6715543 24.0674487,20.3049853 L24.0674487,20.3049853 C24.4340176,19.9384164 24.4340176,19.3431085 24.0674487,18.9765396 L24.0674487,18.9765396 Z" transform="translate(15.000000, 15.000000) scale(1, -1) translate(-15.000000, -15.000000) " />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

const Success = defineComponent({
  props: {
    width: {
      type: String,
      default: '31px'
    },
    height: {
      type: String,
      default: '30px'
    }
  }
})
export default Success
</script>
